import { parse, stringify } from 'qs';
import { ANONYM_USER, IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { authPopup } from 'reactApp/modules/ph/ph.thunkActions';
import { closePopupHelper, openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { PromocodeDialogProps } from 'reactApp/sections/QuotaLanding/PromocodeDialog/PromocodeDialog.types';
import { store as reduxStore } from 'reactApp/store';
import { sendDwh } from 'reactApp/utils/ga';

export const openPromocodeModal = (data?: PromocodeDialogProps) => {
    if (ANONYM_USER) {
        const query = parse(window.location.search, { ignoreQueryPrefix: true }) || {};
        query.action = 'request-promocode';
        const queryString = stringify(query, { addQueryPrefix: true });
        const successPage = `${window.location.origin}${window.location.pathname}${queryString}`;

        reduxStore.dispatch(
            authPopup({
                closable: true,
                loginRequest: true,
                successPage,
            })
        );
    } else {
        const popupName = IS_MOBILE_BROWSER ? popupNames.PROMOCODE_MODAL_MOBILE : popupNames.PROMOCODE_MODAL;

        openPopupHelper({ popupName, data });
    }
};

export const closePromocodeModal = () => {
    const popupName = IS_MOBILE_BROWSER ? popupNames.PROMOCODE_MODAL_MOBILE : popupNames.PROMOCODE_MODAL;
    closePopupHelper(popupName);
};

export const sendPromocodeButtonAnalytics = (action: 'click' | 'show', place: string, platform: 'touch' | 'desktop') => {
    sendDwh({
        eventCategory: 'button-promocodes',
        action: `enter-${action}`,
        dwhData: { platform, place },
    });
};
